module.exports = __webpack_public_path__ + "static/gallery-4-5c0be8bcf5425cfe25a448d71d3b155f.jpg";